module.exports = __webpack_public_path__ + "static/navyTriangle-ba1527925eec61a79c03b920afce1f58.png";